module.exports = __webpack_public_path__ + "static/img/title.4d93a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor6/title.png
// module id = y380
// module chunks = 2